import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CreditCard, CalendarClock } from "lucide-react";
import { SubscriptionPlan } from "./SubscriptionPlans";
import { useToast } from "@/components/ui/use-toast";
import StripesPayment from "@/pages/StripesPayment";

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPlan: SubscriptionPlan | null;
  onSubscribe: (plan: SubscriptionPlan) => void;
  paymentSecret: string;
  setPaymentScreen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
  isOpen,
  onClose,
  selectedPlan,
  onSubscribe,
  paymentSecret,
  setPaymentScreen,
}) => {
  const [paymentMethod, setPaymentMethod] = useState("creditCard");
  const [isProcessing, setIsProcessing] = useState(false);
  const { toast } = useToast();

  const [cardInfo, setCardInfo] = useState({
    cardNumber: "",
    cardName: "",
    expiryDate: "",
    cvv: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCardInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedPlan) return;

    // Simulate payment processing
    setIsProcessing(true);

    setTimeout(() => {
      setIsProcessing(false);

      // Successful subscription
      onSubscribe(selectedPlan);

      // toast({
      //   title: "Subscription Successful",
      //   description: `You are now subscribed to the ${selectedPlan.name} plan.`,
      // });

      // Reset and close
      setCardInfo({
        cardNumber: "",
        cardName: "",
        expiryDate: "",
        cvv: "",
      });
      onClose();
    }, 1500);
  };

  if (!selectedPlan) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Subscribe to {selectedPlan?.name}</DialogTitle>
          <DialogDescription>{selectedPlan?.description}</DialogDescription>
        </DialogHeader>

        <Tabs
          defaultValue="creditCard"
          className="w-full"
          onValueChange={setPaymentMethod}
        >
          <TabsList className="w-full ">
            <TabsTrigger className="w-full" value="creditCard">
              Credit Card
            </TabsTrigger>
            {/* <TabsTrigger value="paypal">PayPal</TabsTrigger> */}
          </TabsList>

          <TabsContent value="creditCard">
            <StripesPayment
              publicSecrete={paymentSecret}
              handleSucess={() => onSubscribe(selectedPlan)}
              setPaymentScreen={setPaymentScreen}
            />
          </TabsContent>

          {/* <TabsContent value="paypal" className="py-4 text-center">
            <p className="mb-4">
              You'll be redirected to PayPal to complete payment.
            </p>
            <Button
              onClick={handleSubmit}
              className="w-full"
              disabled={isProcessing}
            >
              {isProcessing ? "Processing..." : "Pay with PayPal"}
            </Button>
          </TabsContent> */}
        </Tabs>

        {/* <DialogFooter className="sm:justify-start">
          <div className="w-full text-xs text-center text-muted-foreground">
            <p>By subscribing, you agree to our terms and conditions.</p>
            <p>You can cancel your subscription anytime from your account.</p>
          </div>
        </DialogFooter> */}
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionModal;
